import { Button, Image } from "antd";
import { useEffect, useRef, useState } from "react";
import { httpPostUpload } from "../helpers/http.helper";



export const AudioRecorder = ({ onDone = null as any, onStart = null as any})=> {
    const mimeType = "audio/mp3";
    const [permission, setPermission] = useState(false);
    const mediaRecorder = useRef<any>(null);
    const [recordingStatus, setRecordingStatus] = useState<string>("inactive");
    const [stream, setStream] = useState<any>(null);
    const [audioChunks, setAudioChunks] = useState<any[]>([]);
    const [audio, setAudio] = useState<any>(null);
    const [audioFile, setAudioFile] = useState<File>();

    // Volume monitoring states
    const [volume, setVolume] = useState<number>(0);
    const [showMicWarning, setShowMicWarning] = useState<boolean>(false);
    const audioContextRef = useRef<AudioContext | null>(null);
    const analyserRef = useRef<AnalyserNode | null>(null);
    const animationFrameRef = useRef<number | null>(null);
    const volumeCheckTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const hasDetectedSoundRef = useRef<boolean>(false);

    const [stopIcon, setStopIcon] = useState('stop-icon.png');
    const [microphoneIcon, setMicrophoneIcon] = useState('microphone.png');

    // Monitor audio volume levels
    const monitorAudioLevel = (stream: MediaStream) => {
        try {
            const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
            const analyser = audioContext.createAnalyser();
            const microphone = audioContext.createMediaStreamSource(stream);
            
            analyser.smoothingTimeConstant = 0.3;
            analyser.fftSize = 2048;

            microphone.connect(analyser);
            audioContextRef.current = audioContext;
            analyserRef.current = analyser;

            const bufferLength = analyser.fftSize;
            const dataArray = new Uint8Array(bufferLength);

            const updateVolume = () => {
                if (analyserRef.current) {
                    analyserRef.current.getByteTimeDomainData(dataArray);
                    
                    // Calculate RMS (Root Mean Square) for more accurate volume detection
                    let sum = 0;
                    for (let i = 0; i < bufferLength; i++) {
                        const normalized = (dataArray[i] - 128) / 128;
                        sum += normalized * normalized;
                    }
                    const rms = Math.sqrt(sum / bufferLength);
                    // Amplify the volume to reach 40-50% during normal speech
                    const normalizedVolume = Math.min(100, rms * 100 * 7);
                    
                    setVolume(normalizedVolume);

                    // Track if we've detected actual speech (higher threshold to ignore background noise)
                    // Threshold of 8-10 helps distinguish speaking from background noise
                    if (normalizedVolume > 7) {
                        hasDetectedSoundRef.current = true;
                        setShowMicWarning(false);
                    }

                    animationFrameRef.current = requestAnimationFrame(updateVolume);
                }
            };

            updateVolume();

            // Check if microphone is picking up sound after 5 seconds
            volumeCheckTimeoutRef.current = setTimeout(() => {
                if (!hasDetectedSoundRef.current) {
                    setShowMicWarning(true);
                }
            }, 7000);
        } catch (error) {
            console.error("Error setting up audio monitoring:", error);
        }
    };

    const startRecording = async () => {
        if ("MediaRecorder" in window) {
            try {
                const streamData = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false,
                });
                setPermission(true);
                setStream(streamData);

                // Reset warning states
                setShowMicWarning(false);
                hasDetectedSoundRef.current = false;

                // Start monitoring audio levels
                monitorAudioLevel(streamData);

                setRecordingStatus("recording");
                const media = new MediaRecorder(streamData, { type: mimeType } as any);
                mediaRecorder.current = media;
                mediaRecorder.current.start(1000);
                let localAudioChunks = [] as any[];
                mediaRecorder.current.ondataavailable = (event:any) => {
                    if (typeof event.data === "undefined") return;
                    if (event.data.size === 0) return;
                    localAudioChunks.push(event.data);
                };
                setAudioChunks(localAudioChunks);
                onStart && onStart();

            } catch (err:any) {
                alert(err.message);
            }
        } else {
            alert("The MediaRecorder API is not supported in your browser.");
        }
       
    };



    const stopRecording = () => {
        setRecordingStatus("inactive");
        
        // Clean up audio monitoring
        if (animationFrameRef.current) {
            cancelAnimationFrame(animationFrameRef.current);
            animationFrameRef.current = null;
        }
        if (audioContextRef.current) {
            audioContextRef.current.close();
            audioContextRef.current = null;
        }
        if (volumeCheckTimeoutRef.current) {
            clearTimeout(volumeCheckTimeoutRef.current);
            volumeCheckTimeoutRef.current = null;
        }
        
        setVolume(0);
        setShowMicWarning(false);
        hasDetectedSoundRef.current = false;

        mediaRecorder.current.stop();
        mediaRecorder.current.onstop = async () => {
            const audioBlob = new Blob(audioChunks, { type: mimeType });
            const audioUrl = URL.createObjectURL(audioBlob);
         
            const audioFile = new File([audioBlob], 'voice.mp3', { type: 'audio/mp3' });

           // const speech = await httpPostUpload(`voiceToText/upload`,[audioFile]);

        //    const speech = await VoiceToText(audioBlob);

            //console.log(audioUrl);
            //console.log(speech);
            onDone && onDone(audioFile);
            setAudio(audioUrl);
            setAudioFile(audioFile);
            setAudioChunks([]);
        };
    };

   
  const ButtonHoverHandler = async () => {
    setMicrophoneIcon('microphone-white.png');
    setStopIcon('stop-icon-white.png');
  };

  const ButtonOutHandler = async () => {
    setMicrophoneIcon('microphone.png');
    setStopIcon('stop-icon.png');
  };

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
            }
            if (audioContextRef.current) {
                audioContextRef.current.close();
            }
            if (volumeCheckTimeoutRef.current) {
                clearTimeout(volumeCheckTimeoutRef.current);
            }
        };
    }, []);

    return (
        <div className="record-audio-area">
            <div className="audio-controls">
                    {recordingStatus !== "recording" && (
                        <div onClick={startRecording} className="interview-buttons-long link-cursor purple-button"
                        onMouseOver={(e) => ButtonHoverHandler()}
                        onMouseOut={(e) => ButtonOutHandler()}>
                            <Image
                            preview={false}
                            className="icon"
                            height={18}
                            alt=""
                            src={"../assets/"+microphoneIcon} //"microphone.PNG"
                            /> 
                            <span className="icon-inner-text">Record Response</span>
                        </div>
                    )}

                {permission && recordingStatus === "recording" && (
                    <>
                        <div onClick={stopRecording} className="interview-buttons-long link-cursor purple-button"
                        onMouseOver={(e) => ButtonHoverHandler()}
                        onMouseOut={(e) => ButtonOutHandler()}>
                            <Image
                            preview={false}
                            className="icon"
                            width={16}
                            height={16}
                            alt=""
                            src={"../assets/"+stopIcon} //"stop-icon.PNG"
                            /> 
                            <span className="icon-inner-text">Stop Recording</span>
                        </div>
                        
                        {/* Volume Meter */}
                        <div style={{ marginTop: '15px', width: '100%', maxWidth: '100%' }}>
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '10px',
                                marginBottom: '5px',
                                width: '100%'
                            }}>
                                <span style={{ fontSize: '12px', color: '#666', minWidth: '80px', flexShrink: 0 }}>
                                    Microphone:
                                </span>
                                <div style={{
                                    flex: 1,
                                    minWidth: 0,
                                    height: '24px',
                                    backgroundColor: '#e0e0e0',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    border: '1px solid #d0d0d0'
                                }}>
                                    <div style={{
                                        height: '100%',
                                        width: `${volume}%`,
                                        minWidth: volume > 0 ? '1%' : '0%',
                                        backgroundColor: volume > 2 ? '#52c41a' : '#ff4d4f',
                                        transition: 'width 0.05s ease-out, background-color 0.2s ease',
                                        borderRadius: '12px',
                                        boxShadow: volume > 2 ? '0 0 8px rgba(82, 196, 26, 0.5)' : 'none'
                                    }} />
                                </div>
                            </div>
                            
                            {/* Warning message */}
                            {showMicWarning && (
                                <div style={{
                                    padding: '10px',
                                    backgroundColor: '#fff3cd',
                                    border: '1px solid #ffc107',
                                    borderRadius: '5px',
                                    color: '#856404',
                                    fontSize: '13px',
                                    marginTop: '10px'
                                }}>
                                    ⚠️ Your mic is not picking up sound. Please check your microphone settings.
                                </div>
                            )}
                        </div>
                    </>
                )}

                {/* {audio && (
                    <div className="audio-container">
                        <audio src={audio} controls></audio>
                        <a download href={audio}>
                            Download Recording
                        </a>
                    </div>
                )} */}
            </div>
        </div>
    );
}
